import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

import { ThemeProvider } from "@mui/material/styles";
import { createTheme } from "@mui/material";
import api from "./api";
import LoginForm from "./LoginForm";
import { AlertsProvider } from "./Contexts/AlertsContext";

const theme = createTheme({
  components: {
    MuiTextField: {
      defaultProps: {
        variant: "standard",
        fullWidth: true,
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <ThemeProvider theme={theme}>
    <React.StrictMode>
      <AlertsProvider>{api.isLoggedIn ? <App /> : <LoginForm login={(email, password) => api.login(email, password, alert)} />}</AlertsProvider>
    </React.StrictMode>
  </ThemeProvider>
);

reportWebVitals();
